import React from "react";
import { motion } from "framer-motion";

function MissionOne() {
  return (
    <section className="missionone-con position-relative">
      <div className="container">
        <div class="row">
          <div className="col-12 position-relative">

        {/* TITLE */}
        <motion.div
          className="text-center mission_header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          viewport={{ once: true }}
        >
          <h2 className="text-white">The FeStivo PromiSe</h2>
          <div className="heading-underline"></div>
          <p className="text-white">
            Every scoop delivers richness, balance, and unforgettable flavor.
          </p>
        </motion.div>

        {/* PROMISE CARDS */}
        <motion.div
          className="row mt-5"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.25,
              },
            },
          }}
        >

          {[ 
            {
              title: "A Richer Experience",
              desc: "We offer a product with more expressive flavors that feel direct and present."
            },
            {
              title: "Artisanal Versatility",
              desc: "Our mastery allows us to be incredibly versatile - we hand-craft artisanal gelato desserts with the same precision we use to manufacture our premium ice creams."
            },
            {
              title: "Designed for Intensity",
              desc: "By using less air and lower fat, we ensure every spoonful is full and rich, not heavy. "
            }
          ].map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <motion.div
                className="promise-box"
                variants={{
                  hidden: { opacity: 0, y: 50 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.6 }}
              >
                <h2>{item.title}</h2>
                <p dangerouslySetInnerHTML={{ __html: item.desc }} />
              </motion.div>
            </div>
          ))}

        </motion.div>

        {/* SECOND SECTION */}
        <motion.div
          className="crafted_section text-center mt-5"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h2 className="text-white">Global Craft, Indian Soul</h2>
          <div className="heading-underline"></div>

          <p className="text-white">
            We have taken the sophisticated techniques of Italian artisanal Gelato and 
            carefully customized them for the Indian palette. This journey of fusion led us 
            to develop signature Indian-flavored Gelato products that you won't find in
             a traditional Italian gelateria.
          </p>
        </motion.div>

        {/* THIRD SECTION */}
        <motion.div
  className="crafted_section mt-5"
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true }}
>
  <div className="row g-4 justify-content-center">

    {/* BOX 1 */}
    <div className="col-lg-5 col-md-6">
      <div
        className="h-100 p-4 rounded-4"
        style={{
          background: "rgba(255,255,255,0.08)",
          border: "1px solid rgba(255,255,255,0.15)",
          backdropFilter: "blur(10px)",
        }}
      >
        <h4 className="text-white mb-3">
          Local Favorites
        </h4>

        <p className="text-white mb-0">
          We’ve pioneered flavors like Chikoo and Jamun,
          bringing the same dense, smooth gelato texture
          to the fruits we grew up loving.
        </p>
      </div>
    </div>

    {/* BOX 2 */}
    <div className="col-lg-5 col-md-6">
      <div
        className="h-100 p-4 rounded-4"
        style={{
          background: "rgba(255,255,255,0.08)",
          border: "1px solid rgba(255,255,255,0.15)",
          backdropFilter: "blur(10px)",
        }}
      >
        <h4 className="text-white mb-3">
          True Character
        </h4>

        <p className="text-white mb-0">
          Whether it is Italian Pistachio or Indian Jamun,
          our serving temperature allows the flavor molecules
          to release perfectly as they melt on your tongue.
        </p>
      </div>
    </div>

  </div>
</motion.div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionOne;